import React, { FC, InputHTMLAttributes } from 'react'
import { Icon } from '@iconify/react'
import { nanoid } from 'nanoid'
import S from './Checkbox.styles'

type CheckboxProps = InputHTMLAttributes<HTMLInputElement> & {
  id: string
}

const Checkbox: FC<CheckboxProps> = ({
  id,
  name = nanoid(),
  children,
  checked = false,
  disabled = false,
  onChange,
}) => {
  return (
    <S.Wrapper htmlFor={id}>
      <S.HiddenCheckbox id={id} name={name} type="checkbox" checked={checked} disabled={disabled} onChange={onChange} />
      <S.StyledCheckbox checked={checked}>{checked && <Icon icon="bx:check" />}</S.StyledCheckbox>
      {children && <span>{children}</span>}
    </S.Wrapper>
  )
}

export default Checkbox
